import { useEffect } from 'react';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { useLocation, useNavigate } from 'react-router-dom';

import useAuth from 'auth/hook/useAuth';
const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useAuth();

  const from = location.state?.from?.pathname || '/dashboards';

  useEffect(() => {
    if (auth?.accessToken) {
      navigate(from, { replace: true });
    } else {
      navigate('/sign-in', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.accessToken]);

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default HomePage;